import React from 'react';
import PropTypes from 'prop-types';
import IropsOntimeCards from './irops-ontime-cards';
import IropsDelayDelayedCards from './irops-delay-advanced-cards';
import IropsCancelCards from './itops-cancel-cards';
import { sendAnalytics } from '../../analytics/tracker';
import manage from '../../analytics/creators/manage';
import { isIrops } from '../../utilities/helpers';
function IropsSegmentData({
  allDestinationInfo,
  country,
  dispatch,
  flightStatus,
  flightTime,
  language,
  legs,
  oldLegs,
  operationalWindowStatus,
  pnrInfo,
  priorityList,
  stateStoreFront,
  tripType,
  flightSegmentType,
}) {
  if (isIrops()) {
    dispatch(sendAnalytics({
      eventCreator: manage.trackStepInit(pnrInfo),
    }));
  }
  return (
    <React.Fragment>

      { flightSegmentType.includes('flight-delayed') && (
        <IropsDelayDelayedCards
          allDestinationInfo={ allDestinationInfo }
          country={ country }
          delayOnRoundTripOption={ 1 }
          flightTime={ flightTime } 
          language={ language }
          legs={ legs }
          oldLegs={ oldLegs }
          pnrModel={ pnrInfo }
          priorityList={ priorityList }
          stateStoreFront={ stateStoreFront }
          tripType={ tripType }
        />
      )}
      
      { flightSegmentType.includes('flight-cancel') && (
        <IropsCancelCards
          allDestinationInfo={ allDestinationInfo }
          country={ country }
          delayOnRoundTripOption={ 1 }
          flightTime={ flightTime }
          language={ language }
          legs={ legs }
          oldLegs={ oldLegs }
          operationalWindowStatus={ operationalWindowStatus }
          pnrModel={ pnrInfo }
          priorityList={ priorityList }
          stateStoreFront={ stateStoreFront }
          tripType={ tripType } 
        />
      )}

      { flightSegmentType.includes('flight-onTime') && (
        <IropsOntimeCards
          allDestinationInfo={ allDestinationInfo }
          country={ country }
          flightStatus={ flightStatus }
          flightTime={ flightTime }
          language={ language }
          legs={ legs }
          pnrModel={ pnrInfo }
          tripType={ tripType }
        />
      )}
      
    </React.Fragment>
  );
}

IropsSegmentData.propTypes = {
  allDestinationInfo: PropTypes.object,
  country: PropTypes.string,
  flightStatus: PropTypes.string,
  flightTime: PropTypes.string,
  language: PropTypes.string,
  legs: PropTypes.array,
  oldLegs: PropTypes.array,
  pnrInfo: PropTypes.object,
  tripType: PropTypes.number,
};

IropsSegmentData.defaultProps = {
  allDestinationInfo: PropTypes.object,
  country: PropTypes.string,
  flightStatus: PropTypes.string,
  flightTime: PropTypes.string,
  language: PropTypes.string,
  legs: PropTypes.array,
  oldLegs: PropTypes.array,
  pnrInfo: PropTypes.object,
  tripType: PropTypes.number,
};


export default IropsSegmentData;